import React, {useState, useEffect} from 'react';
import {placeholderFromType} from '../../components/common/loading';

import DynamicDestinationRefinementsDesktop from './components/DynamicDestinationRefinementsDesktop';
import DynamicDestinationRefinementsMobile from './components/DynamicDestinationRefinementsMobile';
import {fetchDestinationRefinementsData} from './constants';

import './style.less';

const DestinationRefinementsComponent = (props) => {
    const {
        lbsId,
        mode = 'disabled',
        hasTouch,
        moduleLoaded,
        moduleHidden,
    } = props;

    const [data, setData] = useState(null);

    useEffect(() => {
        fetchDestinationRefinementsData(props).then(setData).catch(setData);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!data) {
        return placeholderFromType(DestinationRefinementsComponent);
    }

    if (data instanceof Error) {
        throw data;
    }

    const {heading, subheading, cards = []} = data;

    if (!cards.length) {
        moduleHidden('dynamic-refinements');
        return null;
    }
    moduleLoaded('dynamic-refinements');

    switch (mode) {
        case 'desktop-control':
            return (
                <DynamicDestinationRefinementsDesktop
                    lbsId={lbsId}
                    heading={heading}
                    subheading={subheading}
                    cards={cards}
                />
            );
        case 'touch-control':
            return (
                hasTouch && (
                    <DynamicDestinationRefinementsMobile
                        lbsId={lbsId}
                        heading={heading}
                        cards={cards}
                    />
                )
            );
        default:
            return null;
    }
};

export default DestinationRefinementsComponent;
